import React, { ReactNode } from "react";

interface SettingsSectionProps {
  title: string;
  children: ReactNode;
  containerClassName?: string; // defaults to settings-page__config-info
}

const SettingsSection: React.FC<SettingsSectionProps> = ({ title, children, containerClassName }) => {
  return (
    <div className="settings-page__section">
      <h2 className="settings-page__section-title">{title}</h2>
      <div className={containerClassName ?? "settings-page__config-info"}>{children}</div>
    </div>
  );
};

export default SettingsSection;


